module.exports = __webpack_public_path__ + "img/红心中级大师@3x.7beaf729.png";